export const forever = { unit: 'month', count: -1 }

export const defaultReasons = ['delete', 'import']
